<template>
    <div class="card_meta" :class="Mousetime ? 'card_shadow' : ''" @mouseover="handleMouseOver"
        @mouseleave="handleMouseLeave" @click="details($event)">
        <img class="imgbox" v-lazy="propsone?.imgurl" :key='propsone?.imgurl' alt="">
        <!-- <video autoplay loop muted class="videobox" v-if="autoplayblen">
            <source :src="propsone?.videourl" type="video/mp4">
        </video> -->
        <video autoplay loop muted class="videobox" @error='videoOnerror' @load="videoOnload" :data-gid="propsone.id"
            :data-gname="propsone.gamename" :src="propsone?.videourl" v-if="autoplayblen" type="video/mp4">
        </video>
        <div class="bottom_title">
            <div class="card_title">{{ propsone?.gamename }}</div>
        </div>
        <div class="select" v-if="propsone?.showtap" @click.stop="de">
            <el-checkbox v-model="checkdata" size="large" @change="datada" />
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref, defineProps, defineEmits, watch, inject } from 'vue'
const autoplayblen = ref(false)
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()
const region = ref({})
const propsone = defineProps({
    videourl: {
        type: String,
    },
    imgurl: {
        type: String,

    },
    gamename: {
        type: String,
    },
    id: {
        type: Number,
    },
    icon: {
        type: String,
    },
    // 是否显示选择按钮
    showtap: {
        type: Boolean,
    },
    // 是否选中
    checkedblen: {
        type: [Boolean, String],
    }
})
const Mousetime = ref(false)
const timenum = ref<any>(0)

const videoOnerror = () => {
    console.log('视频加载失败', propsone.gamename, propsone.id);
}
import { logEventAnalytics } from '@/Firebase/firebase';
let type = inject('sceneType')
const details = (e: any) => {
    e.stopPropagation()
    logEventAnalytics("c_game", {
        gid: propsone.id,
        type: type.value,
    })
    router.push({ path: `/GameDetails/${propsone.id}` })
    console.log(propsone.id, type.value, '场景判断值');
}
const de = () => {
    console.log('1111111');

}
// 创建计时器
const createTimer = (interval: any, onTick: any) => {
    let timerId = null;
    function start() {
        if (timerId !== null) {
            // 如果计时器已经启动，则不执行任何操作
            return;
        }
        timerId = setInterval(onTick, interval);
    }
    function stop() {
        if (timerId !== null) {
            clearInterval(timerId);
            timerId = null;
        }
    }
    return {
        start: start,
        stop: stop
    };
}
const timer = createTimer(1000, () => {
    // 每隔1秒执行一次 悬停三秒触发蒙层
    timenum.value++
    if (timenum.value == 1) {
        Mousetime.value = true
    }
})
const handleMouseOver = () => {
    // 处理移入事件
    autoplayblen.value = true
    // 启动计时器 
    timer.start()
    console.log('移入');
}
const handleMouseLeave = () => {
    timer.stop()
    autoplayblen.value = false
    Mousetime.value = false
    timenum.value = 0
    // 处理移出事件
}
const gamejump = () => {
    console.log(propsone.id, '游戏id');
}
const selecttap = () => {
    console.log('选择');
}
const checkdata = ref(false)
const datada = () => {
    if (checkdata.value) {
        console.log(checkdata.value, '选中');
        emit("selecttap", { gid: propsone.id, sblen: checkdata.value })
    } else {
        console.log(checkdata.value, '取消');
        emit("selecttap", { gid: propsone.id, sblen: checkdata.value })
    }
}
const emit = defineEmits(['selecttap'])
const tap = () => {
    emit("selecttap", '我是子组件传递的数据')
}
watch(propsone, (newvalue, oldvalue) => {
    checkdata.value = newvalue.checkedblen
});

</script>
<style lang="less" scoped>
::v-deep(.el-checkbox) {
    width: 22px;
    height: 22px;
    margin-right: 17px;
    transition-duration: 0.2s;

    .el-checkbox__input {
        width: 100%;
        height: 100%;

        .el-checkbox__original {
            width: 22px !important;
            height: 22px !important;
        }

        .el-checkbox__inner {
            width: 22px !important;
            height: 22px !important;
            border-color: rgba(75, 80, 230, 1) !important;
            background: rgba(75, 80, 230, 0.7)
        }
    }
}

.card_meta {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    position: relative;
    // cursor: pointer;
    border: 2px solid transparent;
    overflow: hidden;
    box-sizing: border-box;
    background: rgb(55, 57, 82);
    transition: all 0.2s ease;
    border-radius: 10px;
    background-clip: padding-box;

    // pointer-events:fill;
    //   box-shadow: 0px 0px 20px 2000px rgba(0, 0, 0, .8) !important;
    .imgbox {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        opacity: 0;
        transition: opacity 0.5s ease-in;
    }

    .imgbox.loaded {
        opacity: 1;
        /* 加载完成时渐显 */
    }

    .videobox {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .bottom_title {
        width: 100%;
        height: 40px;
        color: white;
        background: rgba(0, 0, 0, 0.7);


        position: absolute;
        bottom: -40px;
        transition-duration: 0.3s;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding-left: 9px;
        padding-right: 9px;

        .card_title {
            min-width: 91px;
            height: 23px;
            font-size: 12px;
            font-weight: 800;
            display: flex;
            // justify-content: center;
            align-items: center;
            flex-wrap: nowrap;
        }

        .card_btn:hover {
            opacity: 0.8;
        }
    }

    .icon {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 10px;
        left: 10px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .select {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 10px;
        right: 10px;
        transition-duration: 0.2s;
        pointer-events: inherit;
    }
}

.card_meta:active {
    transform: scale(0.9);
}

.card_meta:hover .bottom_title {
    bottom: 0px;
}

.card_meta:hover {

    border: 2px solid #5142FC;
    // box-shadow: 0px 0px 0px 4px #5142FC, ;
}
</style>